export default __webpack_public_path__ + "static/media/Snd_TryX.c649b6b6.mp3";